import { faqData } from '@/mocks/home';

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
              常见问题
            </h2>
            <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
              关于木瓜影视，你想知道的都在这里
            </p>
          </div>

          <div className="flex flex-col gap-4">
            {faqData.map((faq) => (
              <div
                key={faq.id}
                className="bg-background-100 rounded-lg border border-secondary-200/70 p-5 md:p-6"
              >
                <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-950 mb-3">
                  {faq.question}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}